import React, { Component } from 'react';
import { Link } from 'react-router';
import DocumentTitle from 'react-document-title';
import MoreWork from '../../components/MoreWork';
import ExampleCarousel from '../../components/ExampleCarousel';
import { DesignersImage } from '../../components/Designers';
import { RepertoireImages } from '../../components/Repertoire';
import adobeSoftwareImage from './assets/adobe-software.jpg';
import otherSoftwareImage from './assets/other-software.jpg';
import styles from './styles.scss';

class Talent extends Component {
  render() {
    return (
      <DocumentTitle title='DesignCue - Talent'>
        <div>
          <div className="main-body">
            <div className="container-fluid main-container">
              <div className="col-md-10 col-md-offset-1 col-sm-12">
                <div className="row">
                  <div className="col-md-8 col-md-offset-2">
                    <div className="text-center">
                      <h1>
                        Our Talent
                      </h1>
                      <p className="h3 alt-text demi-bold sub-heading">
                        Work with some of the best <br />
                        product designers in the world.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-10 col-md-offset-1 col-sm-12">
                <DesignersImage />
              </div>
              <div className="col-md-10 col-md-offset-1 col-sm-12">
                <div className="row">
                  <div className="col-md-8 col-md-offset-2">
                    <div className="text-center">
                      <h1 className={styles.red}>
                        An invite-only network of talented designers.
                      </h1>
                      <p className="h3 alt-text demi-bold sub-heading post-text">
                        Vetted, Reliable & Friendly
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="container-fluid main-container">
              <div className="col-md-10 col-md-offset-1 col-sm-12">
                <div className="row">
                  <div className="col-md-8 col-md-offset-2">
                    <div className="text-center bold">
                      <h6 className="alt-heading">
                        EXPERIENCE
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="container-fluid main-container">
              <div className="col-md-10 col-md-offset-1 col-sm-12">
                <div className="container-fluid">
                  <RepertoireImages />
                </div>
              </div>
            </div>
            <div className="container-fluid main-container">
              <div className="col-md-10 col-md-offset-1 col-sm-12">
                <div className="row">
                  <div className="col-md-8 col-md-offset-2">
                    <div className="text-center bold">
                      <div className="h3 alt-text demi-bold sub-heading post-text">
                        Our designers are working at hot startups like Getaround or contracting
                        work from global brands like Nike and Lyft.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="container-fluid main-container">
              <div className="col-md-10 col-md-offset-1 col-sm-12">
                <div className="row">
                  <div className="col-md-8 col-md-offset-2">
                    <div className="text-center bold">
                      <h6 className="alt-heading post-text">
                        EXAMPLE WORK
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <ExampleCarousel />
            <div className="container-fluid main-container">
              <div className="col-md-10 col-md-offset-1 col-sm-12 text-center">
                <div className={styles.quoteSection}>
                  <div className={`${styles.quote} bold blue`}>
                    A designer solves problems by blending art, science, math, psychology, and many other disciplines to create a product for the world to use.
                  </div>
                  <p className="h3 alt-text demi-bold sub-heading">
                    - INVISION
                  </p>
                </div>
              </div>
            </div>
            <div className="container-fluid main-container">
              <div className="col-md-10 col-md-offset-1 col-sm-12">
                <h6 className="bold alt-heading">
                  WHAT THEY'RE LIKE
                </h6>
                <div className="row">
                  <div className="col-sm-10">
                    <div className={`${styles.whatTheyLike} row`}>
                      <div className="col-xs-6 col-sm-4">
                        <ul className="dc-ul">
                          <li>
                            They work efficiently and hit deadlines.
                          </li>
                        </ul>
                      </div>
                      <div className="col-xs-6 col-sm-4">
                        <ul className="dc-ul">
                          <li>
                              They iterate rapidly.
                          </li>
                        </ul>
                      </div>
                      <div className="col-xs-6 col-sm-4">
                        <ul className="dc-ul">
                          <li>
                            They design with development in mind.
                          </li>
                        </ul>
                      </div>
                      <div className="col-xs-6 col-sm-4">
                        <ul className="dc-ul">
                          <li>
                            They're friendly and informative.
                          </li>
                        </ul>
                      </div>
                      <div className="col-xs-6 col-sm-4">
                        <ul className="dc-ul">
                          <li>
                            They love technology and what design can do.
                          </li>
                        </ul>
                      </div>
                      <div className="col-xs-6 col-sm-4">
                        <ul className="dc-ul">
                          <li>
                            They're critical thinkers and problem solvers.
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="container-fluid main-container">
              <div className="col-md-10 col-md-offset-1 col-sm-12">
                <h6 className="bold alt-heading">
                  EXPERTISE
                </h6>
                <div className="row">
                  <div className="col-md-7">
                    <div className="h3 alt-text sub-heading post-text">
                      All DesignCue designers are experienced creators in thought
                      and practice. They work through complex issues on paper and
                      push pixels with the best software you can find.
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-7">
                    <h6 className="alt-text demi-bold">
                      DOMAIN EXPERTISE
                    </h6>
                    <div className={`${styles.domainExpertise} row demi-bold`}>
                      <div className="col-xs-6 col-sm-3">
                        Product Design
                      </div>
                      <div className="col-xs-6 col-sm-3">
                        Animation
                      </div>
                      <div className="col-xs-6 col-sm-3">
                        Interface Design
                      </div>
                      <div className="col-xs-6 col-sm-3">
                        Wireframing
                      </div>
                      <div className="col-xs-6 col-sm-3">
                        Logo Design
                      </div>
                      <div className="col-xs-6 col-sm-3">
                        Prototyping
                      </div>
                      <div className="col-xs-6 col-sm-3">
                        Mobile App Design
                      </div>
                      <div className="col-xs-6 col-sm-3">
                        Web
                      </div>
                    </div>
                  </div>
                  <div className="col-md-5">
                    <h6 className="alt-text demi-bold">
                      SOFTWARE
                    </h6>
                    <div className={styles.software}>
                      <img src={adobeSoftwareImage} alt="adobe software" />
                      <img src={otherSoftwareImage} alt="other software" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="container-fluid main-container">
              <div className="col-md-10 col-md-offset-1 col-sm-12">
                <div className="row">
                  <div className="col-md-8 col-md-offset-2">
                    <div className="text-center bold">
                      <h6 className="alt-heading post-text">
                        MORE WORK
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <MoreWork />
            <hr />
            <div className="container-fluid main-container">
              <div className="col-md-10 col-md-offset-1 col-sm-12">
                <div className="row">
                  <div className="col-md-8 col-md-offset-2">
                    <div className={`${styles.bestWay} text-center`}>
                      <h1 className="blue">
                        The best way to design products.
                      </h1>
                      <p className="h3 demi-bold sub-heading">
                        Good product designers are hard to find, but they're essential to building world-class software.
                        DesignCue allows you to work with some of the best product designers already working for startups.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr className="bg-below" />
            <div className="shapes-bg">
              <div className="container-fluid main-container">
                <div className="col-md-10 col-md-offset-1 col-sm-12">
                  <div className="row">
                    <div className="col-md-8 col-md-offset-2">
                      <div className="mtb100 text-center">
                        <h1 className="mb30">
                          Join our design network
                        </h1>
                        <Link to="/apply" className="btn btn-dc-tertiary">
                          APPLY TO DESIGNCUE
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </DocumentTitle>
    );
  }
}

export default Talent;



// WEBPACK FOOTER //
// ./src/pages/Talent/index.js